import { NAME as name } from './constants';
import { router } from './router';

export const DokladyOjetychVozu = {
	name,
	router,
};
